<template>
  <v-row class="pa-2" no-gutters>
    <v-col
      class="pa-2 sticky-md"
      cols="12"
      md="4"
      style="top: 110px; height: fit-content"
    >
      <v-card
        v-if="resLoading"
        class="d-flex align-center justify-center"
        flat
        min-height="50vh"
      >
        <v-progress-circular
          class="mx-auto"
          indeterminate
          size="50"
          width="5"
        />
      </v-card>
      <component
        :is="theme"
        v-else
        v-model="data"
        :components.sync="specialInfo"
        :ordered.sync="ordered"
      />
    </v-col>

    <v-col class="pa-2 px-0" cols="12" md="8">
      <v-card :disabled="loading" flat>
        <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
          <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
            <div class="row justify-center">
              <div class="col-md-12">
                <p>وارد کردن اطلاعات محصول</p>
              </div>
              <div class="col-md-6 mt-0 pt-0">
                <div class="rowinfo">
                  <v-text-field
                    v-model="data.visitName"
                    :disabled="e6 > 1"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="نام محصول شما"
                    outlined
                  />
                </div>
              </div>

            </div>
          </v-stepper-step>
          <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
            <list-expansion
              flat
              icon="pencil-ruler"
              single
              title="انتخاب طرح قالب "
            >
              <template v-slot:content>
                <theme-selector2
                  v-model="theme"
                  :components="customTheme"
                  :frames="picFrames"
                />
              </template>
            </list-expansion>
            <list-expansion
              v-model="data"
              :components="specialInfo"
              :data="data"
              :service-name="serviceName"
              :component-name="componentName"
              flat
            />

            <div class="col-md-12">
              <next-btn
                :loading="loading"
                style="background: #1b8d39"
                @click="markQr(true)"
              />
            </div>
          </v-stepper-content>
        </v-stepper>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { Bus } from "@/main";
import NewProCard from "@/view/components/Product/newProCard";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import PrevBtn from "@/view/content/fragments/prevBtn";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import ThemeSelector2 from "@/view/pages/product/themeSelector";
import ProductTheme2 from "@/view/pages/product/productTheme2";
import newDesign from "@/view/pages/product/newDesign";
import { mapActions } from "vuex";
import QrMaker from "../qrland/components/qrMaker.vue";

export default {
  name: "editProductModel",
  props:{
    id:{type:String, default:''},
  },
  components: {
    ProductTheme2,
    ThemeSelector2,
    QrCustomize,
    PrevBtn,
    NextBtn,
    ListExpansion,
    NewProCard,
    newDesign,
  },

  data() {
    return {
      ordered: [],
      helpData: [],
      serviceName: "Qrland",
      componentName: "editProduct",
      data: {},
      res: [],
      resLoading: false,
      theme: "",
      qrDesign: {},
      e6: 1,
      errors: {},
      createdId: null,
      shortId: null,
      finish: true,
      loading: false,
      showDialog: false,
      picFrames: [
        { name: "productTheme2", src: "/media/frame/themes/t2.webp" },
        { name: "newProCard", src: "/media/frame/themes/2.svg" },
        { name: "newDesign", src: "/media/bg/product.webp" },
      ],
      customTheme: [
        { name: "newProCard", value: "" },
        { name: "productTheme2", value: "" },
        { name: "newDesign", value: "" },
      ],
      specialInfo: [
        {
          name: "factoryInfo",
          value: "",
          title: "اطلاعات مجموعه",
          subtitle: "",
          icon: "account-outline",
          secondName: "اطلاعات مجموعه",
          iconColor: "#5C6BC0",
          src: "/media/productpro/factoryInfo.gif",
        },

        {
          name: "singleProductEditor",
          value: "",
          title: "اطلاعات محصول",
          subtitle: "",
          icon: "information-outline",
          model: "singleProduct",
          secondName: "اطلاعات محصول",
          iconColor: "#26A69A",
          src: "/media/productpro/Features.gif",

          tabs: [
            {
              title: "نشان اعتماد",
              icon: "mdi-image",
              component: "ArmsChooser",
              model: "arm",
              iconColor: "#4BBAEE",
            },
            {
              title: "دکمه خرید",
              icon: "mdi-button-cursor",
              component: "CallToAction",
              model: "btnSetting",
              iconColor: "#A75CEE",
            },
          ],
        },

        {
          name: "customerClubSettings",
          value: "",
          title: "پیامک عضویت در باشگاه مشتریان",
          subtitle: "",
          icon: "cellphone-message",
          model: "customerClub",
          iconColor: "#A66026",
          src: "/media/productpro/qr.gif",
        },

        {
          name: "Features",
          value: "",
          title: "افزودن ویژگی محصول",
          subtitle: "",
          icon: "information-outline",
          model: "Features",
          secondName: "ویژگی های محصول",
          iconColor: "#8C26A6",
          src: "/media/productpro/singleProduct.gif",
        },
        {
          name: "FeedBack",
          value: "",
          title: "بازخورد",
          subtitle: "",
          icon: "message-reply-text-outline",
          model: "FeedBack",
          secondName: " بازخورد",
          iconColor: "#42A5F5",
          src: "/media/productpro/feedback.gif",
        },
        {
          name: "consultationNew",
          value: "",
          title: "فرم درخواست",
          subtitle: "",
          icon: "form-select",
          model: "consultationNew",
          secondName: " فرم درخواست",
          iconColor: "#FF7043",
          settings: {
            notColor: true,
          },
          src: "/media/productpro/form.gif",
        },
        {
          name: "advanceSettings",
          title: "تنظیمات هوشمند",
          icon: "star-settings-outline",
          model: "advanceSettings",
          iconColor: "#A6266C",
          src: "/media/productpro/advanceSettings.gif",
        },
        {
          name: "voiceGallery",
          title: "افزودن فایل صوتی",
          icon: "microphone",
          model: "audiosGallery",
          secondName: "گالری صوتی",
          iconColor: "#A6264C",
          src: "/media/productpro/voice.gif",
        },

        {
          name: "imageUploader",
          value: "",
          title: "افزودن تصویر",
          subtitle: "",
          icon: "cloud-upload-outline",
          model: "photo",
          secondName: "گالری عکس",
          iconColor: "#2659A6",
          src: "/media/productpro/imageGallery.gif",
        },
        {
          name: "VideoGallery",
          value: "",
          title: "گالری ویدئو",
          secondName: "گالری ویدئو",
          subtitle: "",
          icon: "video-outline",
          iconColor: "#A6269B",
          src: "/media/productpro/VideoGallery.gif",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: "افزودن شبکه های اجتماعی",
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
          secondName: "شبکه های اجتماعی",
          iconColor: "#A4A626",
          src: "/media/productpro/instagram.gif",
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ",
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
          secondName: "",
          iconColor: "#26A637",
          src: "/media/productpro/imageGallery2.gif",
        },
      ],

      headColor: "linear-gradient(to right , #D81A1AFF, #2115A7FF)",
      bodyColors: "",
      eyeStyle: "",
      qrStyle: "",
      qrSize: "",
      dtUrl: null,
      domainId: null,
      qrShow: 1,
      svgMade: "",
      imageMade: "",
      destinationUrl: "",
    };
  },

  mounted() {
    Bus.$on("colorPalette", (value) => {
      this.data.pallete = value;
    });

    Bus.$on("socialMedias", (value) => {
      this.data.socialMedia = value;
    });

    Bus.$on("uploader", (value) => {
      this.data.photo = value;
    });

    Bus.$on("gradientType", (value) => {
      this.data.isGradient = value;
    });
    this.fetchData();
  },

  provide: {
    provideSingleGallery: false,
  },
  computed: {
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
    ...mapActions("local", [
      "updateQrInfo",
      "updateQridentifier",
      "updateQrDomain",
      "updateQrId",
    ]),

    fetchData() {
      const fixData = (data) => {
        let fixed = { ...data.data };

        // fix singleProduct value
        if (!!fixed?.singleProduct) {
          if (!!fixed.singleProduct.title) {
            fixed.singleProduct.name = fixed.singleProduct.title;
            delete fixed.singleProduct.title;
          }
          if (fixed?.photo) {
            fixed.photo = {
              ...fixed.photo,
              hasGame: true,
              hasGif: true,
            };
          }
          if (!fixed.cardSettings) {
            this.$set(fixed, "cardSettings", {
              sizeLevel: 1,
            });
          }

          if (!fixed?.photo?.previewerQr?.previewer) {
            fixed.photo.previewerQr.previewer = {
              gif: "",
              game: null,
              transition: "scale",
            };
          }
          if (fixed.singleProduct.content) {
            fixed.singleProduct.description = fixed.singleProduct.content;
            delete fixed.singleProduct.content;
          }

          if (fixed.singleProduct.details) {
            fixed.singleProduct.extra = fixed.singleProduct.details;
            delete fixed.singleProduct.details;
          }
        }
        //

        // fix video gallery
        if (!fixed.VideoGallery) {
          fixed.VideoGallery = {
            title: fixed.VideoGallerySingle?.name || "گالری ویدئو",
            description: "از ویدئوهای مجموع ما دیدن فرمایید.",
            sectionColor: {
              backGround: "",
              text: "",
            },
          };
        }

        if (!fixed.video_gallery) {
          let videos = fixed.VideoGallerySingle.videos?.map((item) => ({
            name: item.title || "خوش آمدگویی",
            title: "",
            file_link:
              item.url ||
              "https://persian7.asset.aparat.com/aparat-video/1d2d2d8b5fea10b3cbda4fb6e2c45c7653042587-1080p.apt?wmsAuthSign=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjFmMmE5MjgyOWMyZjEzOGNkZmRlMWFlOGU2MzJmNGQxIiwiZXhwIjoxNzE4NDMzMjQ1LCJpc3MiOiJTYWJhIElkZWEgR1NJRyJ9.su36sCl2UH54sLhnn78_dHggUySs2d0CKGs3vW5UTH8",
            description: item.description,
            link: item.link,
          }));

          fixed.video_gallery = [
            {
              name: "گالری",
              images: !!videos?.length
                ? [...videos]
                : [
                    {
                      name: "خوش آمدگویی",
                      title: "",
                      file_link:
                        "https://persian7.asset.aparat.com/aparat-video/1d2d2d8b5fea10b3cbda4fb6e2c45c7653042587-1080p.apt?wmsAuthSign=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjFmMmE5MjgyOWMyZjEzOGNkZmRlMWFlOGU2MzJmNGQxIiwiZXhwIjoxNzE4NDMzMjQ1LCJpc3MiOiJTYWJhIElkZWEgR1NJRyJ9.su36sCl2UH54sLhnn78_dHggUySs2d0CKGs3vW5UTH8",
                      description: "",
                      link: "",
                      id: 15,
                    },
                  ],
            },
          ];
        }

        if (!fixed.audiosGallery)
          fixed.audiosGallery = { audios: [], audioType: "newPlayer" };

        if (Array.isArray(fixed.audiosGallery)) {
          let audios =
            fixed.audiosGallery.length > 0 ? fixed.audiosGallery : [];
          fixed.audiosGallery = {
            audios: audios,
            audioType: "newPlayer",
          };
        }

        if (!!fixed.VideoGallerySingle) delete fixed.VideoGallerySingle;
        //

        // fix photo
        if (!!fixed?.photo && !fixed.photo.background)
          fixed.photo.background = this.$cdnUrl + "/upload/64b2bb1c4ad38.webp";
        //
        if (!!fixed?.photo && fixed.photo.gallery?.length === 0) {
          fixed.photo.gallery = [
            {
              name: "",
              images: [],
            },
          ];
        }
        if (!fixed.companyNumberName) fixed.companyNumberName = "";
        if (!fixed.audiosGallery) fixed.audiosGallery = [];

        return {
          ...data,
          data: fixed,
        };
      };

      this.loading = true;
      this.resLoading = true;

      this.$api
        .get(`qr/template/${this.id}`)
        .then(({ data }) => {
          this.loading = false;
                    // ۱. دریافت صحیح اطلاعات از سرور
          let parsedData =
            typeof data.data.qr.data === "string"
              ? JSON.parse(data.data.qr.data)
              : data.data.qr.data;
          let info = fixData(parsedData);
          this.data = info.data;
          this.theme =
            info.theme && info.theme.length > 0 && info.theme === "newDesign"
              ? "newDesign"
              : info.theme &&
                info.theme.length > 0 &&
                !info.theme === "newDesign"
              ? info.theme
              : "newProCard";
          this.res = data.data;
          this.ordered = info.ordered || [];
        })
        .finally(() => {
          this.loading = false;
          this.resLoading = false;
        });
    },
    markQr(final = false) {
      this.loading = true;
      let obj = {
        type: "productpro",
        qrType: "dynamic",
        title: this.data.visitName,
        data: JSON.stringify({
          theme: this.theme,
          data: this.data,
          ordered: this.ordered || [],

        }),
        qr: {
          section: "#link", link: "https://qr2.in/", backcolor: "#ffffff", frontcolor: "#000000", gradient_color: "#000000", marker_out_color: "#000000", marker_in_color: "#000000", marker_top_right_outline: "#000000", marker_top_right_center: "#000000", marker_bottom_left_outline: "#000000", marker_bottom_left_center: "#000000", framecolor: "#000000", optionlogo: "none", "logo-size": 100, marker: "default", marker_in: "default", outer_frame: "none", framelabel: "SCAN ME", label_font: "AbrilFatface.svg", "label-text-size": 100, size: "248", level: "M",
        },
      };

      this.$api
        .put(`qr/template/${this.id}`, {
          qr: obj,
          type: "productpro",
          title: this.data.visitName,
        })
        .then(({ data }) => {
          this.finish = final;
          this.$toast.success("مدل معرفی محصول پرو شما با موفقیت ساخته شد.");
          this.$router.replace({ name: "modelsList" });
        })
        .catch(({ response }) =>
          console.log("error in get response: ", response),
        )
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
